


























































































import { Component, Prop, Vue } from "vue-property-decorator";
import PortalInput from "@/components/new_style_components/PortalInput.vue";
import PortalDate from "@/components/new_style_components/PortalDate.vue";
import Application from "@/state/Application";
import { ifValid, processError } from "@/utils/ComponentUtils";
import PRILService from "@/services/request/PRILService";
import AddPRILPayload from "@/dto/request/pril/AddPRILPayload";
import SingleFileHolder from "@/components/new_style_components/SingleFileHolder.vue";
import SimpleCompanySearch from "@/components/new_style_components/SimpleCompanySearch.vue";
import CompanyDTO from "@/dto/company/CompanyDTO";
import DictionarySelect from "@/components/new_style_components/DictionarySelect.vue";
import SelectOption from "@/components/common/SelectOption";
import { PRILSource } from "@/constants/request/PRILConstants";
import { prettyEnum } from "@/utils/StringUtils";
import PortalSelect from "@/components/new_style_components/PortalSelect.vue";
import PortalDictionaryDTO from "@/dto/common/PortalDictionaryDTO";
import CommonService from "@/services/CommonService";
import PRILExtension from "@/mixins/PRILExtension";
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";
import {IProfile} from "@/dto/IProfile";
import ProfileDTO from "@/dto/profile/ProfileDTO";

@Component({
	components: {
		SimpleProfileSearch,
		DictionarySelect,
		SimpleCompanySearch,
		PortalDate,
		PortalInput,
		SingleFileHolder,
		PortalSelect,
	}
})
export default class CreatePostalModal extends PRILExtension {
	@Prop()
	private callback!: () => Promise<void>;

	private prilPayload = new AddPRILPayload();

	createPostal(): void {
		ifValid(this, () => {
			if (this.prilPayload.document) {
				Application.startLoading();
				PRILService.addLetter(this.prilPayload).then(
					() => {
						this.$modal.hideAll();
						this.callback();
					},
					err => processError(err, this)
				)
			}
		})
	}

	profileChanged(profile: ProfileDTO): void {
		this.prilPayload.customerId = profile.id;
	}

	get buildSources(): Array<SelectOption> {
		return Object.values(PRILSource).map(source => SelectOption.builder().title(prettyEnum(source)).value(source).build());
	}
}
